<template>
    <div class="rounded-lg bg-white dark:bg-gray-700 text-black dark:text-white p-3 shadow">
        <p class="mb-4">* Steps</p>
        <draggable
            handle=".handle"
            :value="steps"
            @input="data => $emit('input', data)"
            @update="updateOrder"
            ghost-class="opacity-50"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div
                v-for="(step, index) in steps"
                :key="`step_${index}`"
                class="rounded-lg shadow mb-4 relative"
            >
                <div
                    class="flex justify-between items-center cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 p-4"
                    @click="toggleStepCollapse(index)"
                >
                    <div class="handle">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                    </div>
                    <div>
                        {{ step.name }}
                    </div>
                    <div>
                        <svg v-if="!step.collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                        <svg v-if="step.collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                        </svg>
                    </div>
                </div>

                <div class="px-4 pb-4" v-show="step.collapsed">
                    <div class="flex flex-row items-center justify-end mt-3">
                        <button
                            type="button"
                            class="bg-red-500 text-white flex flex-row items-center rounded px-3 py-2"
                            @click="deleteStep(index)"
                        >
                            <svg
                                class="w-4 h-4"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                            </svg>
                            <span class="ml-2">Delete Step</span>
                        </button>
                    </div>

                    <input-text
                        name="name"
                        label="* Name"
                        v-model="step.name"
                        :error="errors[`steps.${index}.name`] ? errors[`steps.${index}.name`][0] : null"
                        :maxlength="255"
                    />

                    <input-rich-text
                        name="description"
                        label="* Description"
                        v-model="step.description"
                        :key="`step_description_${index}`"
                        :error="errors[`steps.${index}.description`] ? errors[`steps.${index}.description`][0] : null"
                        :maxlength="5000"
                        :language="language"
                    />

                    <media-reference
                        :key="`media${step.id || step.key}`"
                        v-model="step.image"
                        :language="language"
                        class="mt-3"
                        label="* Image"
                        :media-types="['Image']"
                        :error="errors[`steps.${index}.image.id`] ? errors[`steps.${index}.image.id`][0] : null"
                    />
                </div>
            </div>
        </draggable>
        <Btn
            content="Add Step"
            class="mt-3"
            type="button"
            @click="addStep"
        />

        <p v-if="errors.steps" class="text-red-800 dark:text-red-400 mt-2 text-sm">{{ errors.steps[0] || '' }}</p>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../stores/froala";
export default {
    name: "HowToSteps",
    components: {draggable},
    props: {
        value: {
            type: Array,
            required: true,
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        language: Object,
    },
    data: function(){
        return {
            steps: this.value,
            froalaStore: useFroalaStore(),
        }
    },
    mounted: function(){
        this.steps.map(step => {
            step.collapsed = false;
            return step;
        });
    },
    methods: {
        addStep: function(){
            this.steps.push({
                key: Math.random().toString(16).substr(2, 8),
                heading: '',
                text: '',
            });
            this.updateOrder();
        },
        deleteStep: function(index){
            this.steps.splice(index, 1);
            this.updateOrder();
        },
        updateOrder: function(){
            const steps = [...this.steps];
            this.steps = steps.map((step, index) => {
                step.order = index;
                return step;
            });
            this.$emit('input', this.steps)
        },
        toggleStepCollapse: function(stepIndex){
            const steps = [...this.steps];
            steps[stepIndex].collapsed = !steps[stepIndex].collapsed;
            this.steps = steps;
        },
    },
    watch: {
        value: function(newValue){
            this.steps = newValue;
        }
    },

}
</script>
